import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var User = namespace('user');
var Common = namespace('common');

var ProtocolLog = function (_super) {
  __extends(ProtocolLog, _super);

  function ProtocolLog() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ProtocolLog.prototype.handleLogout = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.user.logOff()];

          case 1:
            _a.sent();

            this.$message.warning(this.t('注销成功'));
            return [4, this.$router.push({
              name: 'CustomerLogoutAccountCompletedPage'
            })];

          case 2:
            _a.sent();

            this.$nextTick(function () {
              _this.clearUserData();
            });
            return [2];
        }
      });
    });
  };

  ProtocolLog.prototype.handleNext = function () {
    this.$emit('next', this.$enum.mine.LogoutStepEnum.LogoutPrompt);
  };

  ProtocolLog.prototype.created = function () {};

  __decorate([Common.Getter('commonBizList')], ProtocolLog.prototype, "commonBizList", void 0);

  __decorate([User.State('userInfo')], ProtocolLog.prototype, "userInfo", void 0);

  __decorate([User.Action('clearUserData')], ProtocolLog.prototype, "clearUserData", void 0);

  ProtocolLog = __decorate([Component], ProtocolLog);
  return ProtocolLog;
}(Vue);

export default ProtocolLog;